<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Scheduled Maintenance</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onAdd()"
          matTooltip="Click this button to create a new maintenance schedule.">
          <mat-icon>add</mat-icon>
          Add Schedule
        </button>

        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>archive</mat-icon> Archive Selected
          </button>

          <button *ngIf="dataSource.filters.archived == 'true'" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>restore</mat-icon> Restore Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Asset Maintenance Schedules." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search for Maintenance Schedules."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let record">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(record.id) : null"
            [checked]="dataSource.selection.isSelected(record.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the maintenance schedule.">
          #
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ schedule.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the maintenance schedule." [style.width.px]="250">
          Title
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ schedule.title }}
        </td>
      </ng-container>

      <ng-container matColumnDef="schedule_mode">
        <th mat-header-cell *matHeaderCellDef>
          Schedule Mode
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ assetMaintenanceSchedulesService.getScheduleModeLabel(schedule.schedule_mode) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="maintenance_type">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="200">
          Maintenance Type
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ assetMaintenanceSchedulesService.getMaintenanceTypeLabel(schedule.maintenance_type) }}
          <ng-container *ngIf="assetMaintenanceRecordsService.isOtherType(schedule.maintenance_type) && schedule.maintenance_type_other">
            - {{ schedule.maintenance_type_other }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="flags">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="100">
          Flags
        </th>
        <td mat-cell *matCellDef="let schedule" class="no-padding text-wrap">
          <mat-icon *ngIf="schedule.enabled" matTooltip="Schedule Enabled." class="schedule-enabled-yes">power_settings_new</mat-icon>
          <mat-icon *ngIf="schedule.is_recurring" matTooltip="Recurring Schedule." class="recurring-yes">repeat</mat-icon>
          <mat-icon *ngIf="schedule.auto_create" matTooltip="Automatically Creates Maintenance Records." class="auto-create-yes">note_add</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="default_priority">
        <th mat-header-cell *matHeaderCellDef>
          Default Priority
        </th>
        <td mat-cell *matCellDef="let schedule">
          <span [style.color]="assetMaintenanceRecordsService.getPriorityColor(schedule.default_priority) || null">
            {{ assetMaintenanceSchedulesService.getPriorityLabel(schedule.default_priority) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="next_due_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the maintenance schedule.">
          Next Due Date
        </th>
        <td mat-cell *matCellDef="let schedule">
          <span [style.color]="utils.getDueDateColor(schedule.next_due_at) || null">
            {{ schedule.next_due_at ? ((schedule.next_due_at * 1000) | timezoneConvertMedium) : '' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="next_auto_create_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the auto create date of the maintenance schedule.">
          Next Auto Create Date
        </th>
        <td mat-cell *matCellDef="let schedule">
          <span [style.color]="utils.getDueDateColor(schedule.next_auto_create_at) || null">
            {{ schedule.next_auto_create_at ? ((schedule.next_auto_create_at * 1000) | timezoneConvertMedium) : '' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="users">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Assigned Users
        </th>
        <td mat-cell *matCellDef="let schedule" class="no-padding">
          <ng-container *ngIf="schedule?.users?.length">
            <span *ngFor="let user of schedule.users | slice:0:MAX_VISIBLE_ASSIGNED_USERS">
              <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
                {{ user.contact_person }}
              </a><br>
            </span>
            <span *ngIf="schedule.users.length > MAX_VISIBLE_ASSIGNED_USERS" [matTooltip]="getRemainingUsersTooltip(schedule.users)">
              {{ schedule.users.length - MAX_VISIBLE_ASSIGNED_USERS }} more users
            </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the maintenance schedule was added.">
          Created At
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ (schedule.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
        <td mat-cell *matCellDef="let schedule">
          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onView(schedule.id)">
            View
          </button>
          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onEdit(schedule)">
            Edit
          </button>
          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onRemove(schedule)">
            Archive
          </button>
          <button *ngIf="dataSource.filters.archived == 'true'" type="button" mat-button (click)="onRestore(schedule.id)">
            Restore
          </button>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>

